// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { ShipmentPackageDto, ShipmentPackageLineDto } from "@insite/client-framework/Types/ApiModels";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ProductLineComponentModel } from "@store/Library/Components/ProductLine/ProductLine";
import { orderV2Props } from "@store/Themes/common/props/orderV2";
import React, { FC } from "react";

export interface ProductLineNotesProps {
    productLine?: ProductLineComponentModel;
}

export type Shipment = ShipmentPackageLineDto & Partial<ShipmentPackageDto>;

export interface ProductLineNotesStyles {
    wrapper?: InjectableCss;
    label?: TypographyPresentationProps;
    value?: TypographyPresentationProps;
}

export const ProductLineNotesStyles: ProductLineNotesStyles = {
    wrapper: orderV2Props.infoWrapper,
    label: orderV2Props.infoLabel,
    value: orderV2Props.infoValue,
};

const styles = ProductLineNotesStyles;

const ProductLineNotes: FC<ProductLineNotesProps> = ({ productLine }) => {
    if (!productLine?.notes || productLine.notes.length === 0) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="order_line_notes">
            <Typography {...styles.label}>{translate("Item Notes")}</Typography>
            <Typography {...styles.value}>{productLine.notes}</Typography>
        </StyledWrapper>
    );
};

export default ProductLineNotes;
